// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1ihh1","footer":"ModalUpdate_footer__3ydy2"};